export const TOAST_MESSAGES_DELETE_SPACE = {
  DELETE_SPACE_ERROR: 'Error delete ticketing space, please try again',
  DELETE_SPACE_SUCCESS: 'Space deleted successfully!',
};

export const BANNER_TITLE = 'Please double-check before deleting. This action is permanent.';

export const DESCRIPTION = (
  <>
    Are you sure you want to delete this space? <br /> Deleting this space will{' '}
    <strong className="font-bold">permanently remove all columns and tickets,</strong> and{' '}
    <strong className="font-bold">all members</strong> will be <strong className="font-bold">removed</strong> from the
    space.
  </>
);
